import { render, staticRenderFns } from "./TeacherMaterialsView.vue?vue&type=template&id=4a429fbf&scoped=true&"
import script from "./TeacherMaterialsView.vue?vue&type=script&lang=js&"
export * from "./TeacherMaterialsView.vue?vue&type=script&lang=js&"
import style0 from "./TeacherMaterialsView.vue?vue&type=style&index=0&id=4a429fbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a429fbf",
  null
  
)

export default component.exports